import { FilterMatch, FilterOperator } from '../schemas'
import { z } from 'zod'

export const TableSourcesSchema = z.array(
  z.object({
    id: z.string().uuid(),
    document_id: z.string().uuid().nullable(),
    document_name: z.string(),
    status: z.enum(['ready', 'pending', 'running', 'completed', 'failed', 'cancelled']),
    rows_created: z.number().int().nonnegative(),
    error: z.string().nullable(),
    removal_blocked_reason: z.string().nullable().optional(),
  })
)
export type TableSources = z.infer<typeof TableSourcesSchema>

export const TableSourcePageSchema = z.object({
  items: TableSourcesSchema,
  total: z.number().int().nonnegative(),
  matched: z.number().int().nonnegative(),
  processing: z.number().int().nonnegative(),
})
export type TableSourcePage = z.infer<typeof TableSourcePageSchema>
// Shared grid controls emit general column filters; narrow them at the source-view boundary.
export const SourceFiltersSchema = z.array(
  z.discriminatedUnion('column_id', [
    z.object({
      column_id: z.literal('document_name'),
      operator: z.enum([FilterOperator.Contains, 'not_contains', FilterOperator.Equals]),
      value: z.string(),
    }),
    z.object({ column_id: z.literal('status'), operator: z.literal(FilterOperator.Equals), value: z.string() }),
    z.object({
      column_id: z.literal('rows_created'),
      operator: z.enum([FilterOperator.Equals, FilterOperator.Greater, FilterOperator.Less]),
      value: z.string(),
    }),
  ])
)
export const SourceSortsSchema = z.array(z.object({ column_id: z.enum(['document_name', 'status', 'rows_created']), descending: z.boolean() }))
export type TableSourceQuery = {
  search?: string
  search_filenames?: boolean
  status?: TableSources[number]['status']
  filter_match?: FilterMatch
  filters: z.infer<typeof SourceFiltersSchema>
  sorts: z.infer<typeof SourceSortsSchema>
  offset: number
  limit: number
}
